import Vue from 'vue'
import Mixins from '@liveeps/utilities/mixins'
import BookingEngine from '@liveeps/components/blocks/booking-engine.vue'
import SentryInit from '@src/sentry'

// site specific components and settings
export default function site_config() {
  Vue.component('booking-engine', BookingEngine)
  Vue.mixin(Mixins)
  SentryInit()
}
